import {
  GET_CARGO_LIST,
  GET_CARGO_LIST_SUCCESS,
  GET_CARGO_LIST_FAIL,
  GET_SINGLE_CARGO,
  GET_SINGLE_CARGO_SUCCESS,
  GET_SINGLE_CARGO_FAIL,
  DELETE_CARGO_REQUEST,
  DELETE_CARGO_SUCCESS,
  DELETE_CARGO_FAIL,
  ADD_CARGO_REQUEST,
  ADD_CARGO_SUCCESS,
  ADD_CARGO_FAIL,
  UPDATE_CARGO_REQUEST,
  UPDATE_CARGO_SUCCESS,
  UPDATE_CARGO_FAIL,
} from "src/constants/types";

export const cargoReducer = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CARGO_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CARGO_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        cargoList: actions.payload,
        error: "",
      };
    case GET_CARGO_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CARGO:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CARGO_SUCCESS:
      return {
        ...state,
        loading: false,
        selected_cargo: actions.payload,
      };
    case GET_SINGLE_CARGO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CARGO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CARGO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CARGO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CARGO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CARGO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CARGO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CARGO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CARGO_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CARGO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
